import React, { useState, useEffect, useContext } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { useParams, Link, useHistory, useLocation } from "react-router-dom";
import { BsCreditCard } from "react-icons/bs";
import { FaPiggyBank } from "react-icons/fa";
import { BsExclamationCircle } from "react-icons/bs";
import { MdContentCopy } from "react-icons/md";
import { CoinContext } from "../../contexts/CoinContext";
import * as Sentry from "@sentry/react";
import { REACT_APP_PROD_URL } from "../../services/configs";
import useResizer from "../../services/useResizer";
import Icon from "../../fontIcons/icon";
import styled from "styled-components";
import { useSelector } from "react-redux";
import qs from "query-string";
import useSWR from "swr";
import numberCurrencyIn from "../../services/indian-formatting";
import fetcher from "../../api/swr_fetcher";
import {
  Button,
  Divider,
  FormControl,
  MenuItem,
  Select,
  withStyles,
} from "@material-ui/core";
import { copyTextAndSendToApp } from "../../services/appMethods";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import INRBalanceCard from "../INRDeposit/INRBalanceCard";
import step1deposit from "../../assets/staticAssets/step1deposit.png";
import step2deposit from "../../assets/staticAssets/step2deposit.png";
import step3deposit from "../../assets/staticAssets/step3deposit.png";
import { Formik } from "formik";
import axios from "axios";
import Tooltip from "@material-ui/core/Tooltip";
import { Close, Info } from "@material-ui/icons";
import Zoom from "@material-ui/core/Zoom";
import Checkmark from "../../components/Checkmark";

const StyledTooltip = withStyles({
  tooltipPlacementTop: {
    marginLeft: "-150px",
    fontSize: "14px",
    lineHeight: "1.2rem",
    // margin: "4px 0 4px -8px",
  },
})(Tooltip);

export default function DirectDeposit(props) {
  const isMobile = useResizer();
  const classes = useStyles();
  const { handleClickAlert, bannedTimeout } = useContext(CoinContext);
  const token = useSelector((state) => state.trading.TOKEN);

  const [limit, setLimit] = useState({
    min: 500,
    max: 2000000,
  });
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [transactionStatus, setTransactionStatus] = useState("NOT_STARTED");
  const [transactionErrorMessage, setTransactionErrorMessage] = useState(null);

  let history = useHistory();

  const { data, error } = useSWR(`/v1/transfers/deposit_info`, fetcher, {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  });
  const { data: limitData } = useSWR(`/v1/inrConfig`, fetcher, {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  });
  const { data: depositConfig } = useSWR(
    `/v1/transfers/depositConfig`,
    fetcher,
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    }
  );

  const { data: bankAccount } = useSWR(`/v1/um/bankAccount`, fetcher, {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  });

  const { data: account } = useSWR(`/v1/account`, fetcher, {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  });

  useEffect(() => {
    if (limitData) generateLimitData(limitData);
  }, [limitData]);

  function generateLimitData(data) {
    setLimit({
      min: data.minWithdraw,
      max: data.maxWithdraw,
    });
  }

  useEffect(() => {
    if (error?.status === 401) {
      bannedTimeout("timeout");
    } else if (error?.status === 403) {
      bannedTimeout("banned");
    }
  }, [error]);

  async function sendRequest(amount, utr, type) {
    setTransactionStatus("PROCESSING");
    const options = {
      headers: {
        Authorization: "Bearer " + token,
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/json",
        "access-control-allow-origin": "*",
        "Access-Control-Allow-Credentials": true,
      },
    };
    try {
      let response = await axios.post(
        REACT_APP_PROD_URL + `/v1/transfers/deposits`,
        {
          referenceId: utr,
          amount: amount,
          transferType: type,
        },
        options
      );
      response = response.data;
      setTransactionStatus("SUCCESS");
    } catch (err) {
      let readableError = err.response?.data?.detail?.match(/"([^']+)"/)[1];
      setTransactionStatus("FAILED");
      setTransactionErrorMessage(readableError);
    }
  }
  return (
    <div className={classes.container}>
      <h1 className="mb-3"> Direct Bank Deposit</h1>
      <p className="font-light mb-5">
        <span
          className="underline cursor-pointer"
          onClick={() => {
            if (isMobile) {
              history.push(`/wallet/inr`);
            } else {
              history.push(`/wallet/inr`);
            }
          }}
        >
          Wallet
        </span>{" "}
        {">"}{" "}
        <span
          className="underline cursor-pointer"
          onClick={() => {
            history.push(`/inr/deposit`);
          }}
        >
          Deposit INR
        </span>{" "}
        <span style={{ color: "#3AC4AB" }}> Direct Bank Deposit</span>
      </p>
      <div className={classes.gridContainer}>
        <INRBalanceCard></INRBalanceCard>
        <Divider />
        <div className={classes.subContainer}>
          <center>
            <h2 className="mb-6 mt-6">
              Use Direct Bank Deposits in <br className="md:hidden"></br>3 Easy
              Steps
            </h2>
          </center>
          <br></br>
          <div className="flex  md:flex-nowrap flex-wrap text-center justify-between">
            <div className="flex flex-col items-center mb-10 md:mx-3">
              <h3 className="font-semibold text-gray-500 mb-7">STEP 1</h3>
              <img
                src={step1deposit}
                className="mb-7 w-[50px] md:w-[80px] "
              ></img>
              <p>
                Copy latest Bank account details from this page and add as
                beneficiary to your bank.
              </p>
            </div>
            <div className="flex flex-col items-center  mb-10 md:mx-3">
              <h3 className="font-semibold text-gray-500 mb-7">STEP 2</h3>
              <img
                src={step2deposit}
                className="mb-7 w-[50px] md:w-[80px]"
              ></img>
              <p>
                Transfer funds Via IMPS/NEFT/RTGS and note down the
                UTR/Reference number provided by the bank.
              </p>
            </div>{" "}
            <div className="flex flex-col items-center  mb-10 md:mx-3">
              <h3 className="font-semibold text-gray-500 mb-7">STEP 3</h3>
              <img
                src={step3deposit}
                className="mb-7 md:mb-12 w-[50px] md:w-[80px]"
              ></img>
              <p>
                Submit the amount and the UTR/Reference number on this page to
                claim your deposit. (Claim request mandatory)
              </p>
            </div>
          </div>
        </div>{" "}
        <Divider></Divider>
        <div className={classes.subContainer}>
          {" "}
          <h3 className="mb-3 text-pb-primary-100">
            Account Details For Bank Deposit
          </h3>
          <div className="dark:bg-[#111111] bg-gray-100 px-4 py-2 rounded-md shadow-md mb-5">
            <div className={classes.flexContainer} style={{ marginTop: "5px" }}>
              <p className={classes.ptitle}>Beneficiary Name</p>
              <p className={`${classes.pvalue} ml-3`}>
                {depositConfig?.beneName}
              </p>
              <div className={classes.grow} />
              <MdContentCopy
                className={classes.copyIcon}
                onClick={() => {
                  navigator.clipboard.writeText(depositConfig?.beneName);
                  copyTextAndSendToApp(depositConfig?.beneName);
                  handleClickAlert("success", "Copied!");
                }}
              />
            </div>

            <div className={classes.flexContainer} style={{ marginTop: "5px" }}>
              <p className={classes.ptitle}>Account Number</p>
              <p className={`${classes.pvalue} ml-3`}>
                {depositConfig?.accountNo}
              </p>
              <div className={classes.grow} />
              <MdContentCopy
                className={classes.copyIcon}
                onClick={() => {
                  navigator.clipboard.writeText(depositConfig?.accountNo);
                  copyTextAndSendToApp(depositConfig?.accountNo);
                  handleClickAlert("success", "Copied!");
                }}
              />
            </div>
            <div className={classes.flexContainer} style={{ marginTop: "5px" }}>
              <p className={classes.ptitle}>IFSC</p>
              <p className={`${classes.pvalue} ml-3`}>{depositConfig?.ifsc}</p>
              <div className={classes.grow} />
              <MdContentCopy
                className={classes.copyIcon}
                onClick={() => {
                  navigator.clipboard.writeText(depositConfig?.ifsc);
                  copyTextAndSendToApp(depositConfig?.ifsc);
                  handleClickAlert("success", "Copied!");
                }}
              />
            </div>
            <div className={classes.flexContainer} style={{ marginTop: "5px" }}>
              <p className={classes.ptitle}>
                Remark{" "}
                <span className="text-red-500 font-bold">(Required)</span>
              </p>
              <p className={`${classes.pvalue} ml-3`}>{account?.phonenumber}</p>
              <div className={classes.grow} />
              <MdContentCopy
                className={classes.copyIcon}
                onClick={() => {
                  navigator.clipboard.writeText(account?.phonenumber);
                  copyTextAndSendToApp(depositConfig?.phonenumber);
                  handleClickAlert("success", "Copied!");
                }}
              />
            </div>
          </div>
          <div className="text-gray-400">
            <h4>Pay Only From</h4>
            <div>
              {" "}
              <div
                className={classes.flexContainer}
                style={{ marginTop: "5px" }}
              >
                <p className={classes.ptitle}>Account Number</p>
                <p className={`${classes.pvalue} ml-3`}>
                  {bankAccount?.accountNumber}
                </p>
                <div className={classes.grow} />
              </div>
            </div>{" "}
            <div className={classes.flexContainer} style={{ marginTop: "5px" }}>
              <p className={classes.ptitle}>IFSC Code</p>
              <p className={`${classes.pvalue} ml-3`}> {bankAccount?.ifsc}</p>
              <div className={classes.grow} />
            </div>
          </div>
        </div>
        <div className={classes.subContainer}>
          <div
            className="flex"
            style={{
              borderBottomStyle: "solid",
              paddingBottom: "5px",
              borderColor: "red",
              borderWidth: "2px",
            }}
          >
            <BsExclamationCircle style={{ fontSize: "20px", color: "red" }} />
            <p
              style={{
                color: "red",
                fontWeight: "bold",
                marginLeft: "15px",
              }}
            >
              Note
            </p>
          </div>
          <ol
            style={{
              marginTop: "10px",
              marginLeft: "25px",
              color: "#9fa1a0",
            }}
          >
            <li>
              Remarks related to crypto eg. (Crypto, BTC, etc) will be rejected,
              use only <strong>registered mobile number as remark.</strong>
            </li>
            <li>{`Minimum Deposit ${
              limitData?.minDeposit || 0
            } INR, Maximum Deposit ${limitData?.maxDeposit || 0} INR`}</li>
            <li>
              {" "}
              Direct bank deposits are manual and may take a few hours to
              reflect after creating the deposit request.
            </li>
          </ol>
        </div>
        <Divider></Divider>
        <div className={classes.subContainer}>
          {" "}
          <h3 className="mb-3 text-pb-primary-100">Create A Deposit Request</h3>
          <div className="dark:bg-[#111111] bg-gray-100 p-4 rounded-md shadow-md mb-5">
            <Formik
              initialValues={{ amount: "", utr: "", type: "IMPS" }}
              validate={(values) => {
                const errors = {};
                if (values.utr.length > 30) {
                  errors.utr = "Invalid UTR";
                }
                return errors;
              }}
              onSubmit={(values, { setSubmitting }) => {
                setShowConfirmation(true);
                setSubmitting(false);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                resetForm,
                /* and other goodies */
              }) => (
                <>
                  <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                      <label for="amount">
                        <strong className="text-sm">Amount</strong>
                      </label>
                      <input
                        min="500"
                        max="1000000"
                        type="number"
                        required
                        name="amount"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.amount}
                        placeholder="Enter Deposit Amount"
                        className="dark:bg-[#161921] rounded-sm w-full md:w-[50%]  dark:text-white  px-2 mb-2"
                        style={{
                          border: "none",
                          height: "40px",
                          fontSize: "14px",
                          boxShadow: "inset 0px 2px 7px rgba(0, 0, 0, 0.56)",
                        }}
                      />
                      <div className={classes.error}>
                        {errors.amount && touched.amount && errors.amount}
                      </div>
                    </div>
                    <div className="mb-4">
                      <label for="utr" className="flex items-center">
                        <strong className="text-sm">
                          UTR / Reference Number
                        </strong>
                        <StyledTooltip
                          title="UTR or Reference number is a unique number provided by the bank after a successful IMPS/NEFT/RTGS transfer to track the status. It can be found in your bank statement or on the transaction successful screen."
                          placement="top-start"
                          TransitionComponent={Zoom}
                          enterTouchDelay={0}
                          leaveTouchDelay={10000}
                        >
                          <Info
                            style={{
                              cursor: "pointer",
                              fontSize: "18px",
                              marginLeft: "10px",
                              color: "#999",
                            }}
                          ></Info>
                        </StyledTooltip>
                      </label>
                      <input
                        type="text"
                        required
                        name="utr"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.utr}
                        placeholder="Enter UTR / Reference Number"
                        className="dark:bg-[#161921] rounded-sm w-full md:w-[50%]  dark:text-white  px-2 mb-2"
                        style={{
                          border: "none",
                          height: "40px",
                          fontSize: "14px",
                          boxShadow: "inset 0px 2px 7px rgba(0, 0, 0, 0.56)",
                        }}
                      />
                      <div className={classes.error}>
                        {errors.utr && touched.utr && errors.utr}
                      </div>
                    </div>
                    <div className="mb-6">
                      {" "}
                      <label for="type" className="flex items-center">
                        <strong className="text-sm">Payment Mode</strong>
                      </label>
                      <FormControl
                        variant="outlined"
                        margin="dense"
                        className={"dark:bg-[#161921] rounded-sm"}
                        style={{
                          boxShadow: "inset 0px 2px 7px rgba(0, 0, 0, 0.56)",
                        }}
                      >
                        <Select
                          required
                          MenuProps={{
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "left",
                            },
                            getContentAnchorEl: null,
                          }}
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          value={values.type}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          name="type"
                        >
                          <MenuItem value="IMPS" style={{ minWidth: "80px" }}>
                            IMPS
                          </MenuItem>
                          <MenuItem value="NEFT" style={{ minWidth: "80px" }}>
                            NEFT
                          </MenuItem>
                          <MenuItem value="RTGS" style={{ minWidth: "80px" }}>
                            RTGS
                          </MenuItem>
                          {/* <MenuItem value="UPI" style={{ minWidth: "80px" }}>
                            UPI
                          </MenuItem> */}
                        </Select>
                      </FormControl>
                    </div>
                    <div className="flex md:justify-center w-full">
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className="bg-pb-primary-100 border-none text-white font-bold px-6 p-3 cursor-pointer hover:opacity-70 transition-all w-full md:w-auto"
                        style={{ borderRadius: "30px", minWidth: "200px" }}
                      >
                        <h3>Create A Request</h3>
                      </button>
                    </div>
                  </form>
                  <Dialog
                    open={showConfirmation}
                    // onClose={handleLogoutDialogClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      {transactionStatus == "SUCCESS"
                        ? "Request Successful"
                        : transactionStatus == "FAILED"
                        ? "Request Failed"
                        : "Confirmation"}
                    </DialogTitle>
                    <DialogContent className="mb-5">
                      {transactionStatus == "SUCCESS" ? (
                        <div className="text-center">
                          <div className="flex justify-center -mt-5 ">
                            <Checkmark></Checkmark>
                          </div>
                          The INR deposit request has been accepted for review!
                          The amount will be verified by our team and added to
                          your INR wallet.
                        </div>
                      ) : transactionStatus == "FAILED" ? (
                        <div className="text-center">
                          <div
                            style={{ color: "red" }}
                            className="flex justify-center mb-3 -mt-2"
                          >
                            <Close style={{ fontSize: "60px" }}></Close>
                          </div>
                          {transactionErrorMessage}
                        </div>
                      ) : (
                        <>
                          Are you sure you want to submit a Direct Bank Deposit
                          request for{" "}
                          <strong className="text-pb-primary-100">
                            ₹{values.amount} ({numberCurrencyIn(values.amount)})
                          </strong>{" "}
                          with a UTR/Reference Number{" "}
                          <strong className="text-pb-primary-100">
                            {values.utr}
                          </strong>{" "}
                          and{" "}
                          <strong className="text-pb-primary-100">
                            {values.type}
                          </strong>{" "}
                          payment mode.
                        </>
                      )}
                    </DialogContent>
                    <DialogActions
                      style={{ paddingBottom: "20px", paddingRight: "15px" }}
                    >
                      <Button
                        onClick={() => {
                          setShowConfirmation(false);
                          if (transactionStatus == "SUCCESS") {
                            resetForm();
                          }
                          setTimeout(() => {
                            setTransactionStatus("NOT_STARTED");
                          }, 500);
                        }}
                        color="primary"
                        variant="outlined"
                        style={{ fontWeight: "bold" }}
                      >
                        {transactionStatus == "NOT_STARTED" ? "Cancel" : "Okay"}
                      </Button>
                      {(transactionStatus == "NOT_STARTED" ||
                        transactionStatus == "PROCESSING") && (
                        <Button
                          onClick={() => {
                            sendRequest(values.amount, values.utr, values.type);
                          }}
                          disabled={
                            transactionStatus == "PROCESSING" ? true : false
                          }
                          color="primary"
                          variant="contained"
                          autoFocus
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          {transactionStatus == "PROCESSING"
                            ? "Please wait..."
                            : "Confirm"}
                        </Button>
                      )}
                    </DialogActions>
                  </Dialog>
                </>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    flexGrow: 1,
    [theme.breakpoints.up("lg")]: {
      width: "52%",
    },
    marginLeft: "auto",
    marginRight: "auto",
  },
  grow: {
    flexGrow: 1,
  },
  error: {
    color: "red",
  },
  link: {
    fontWeight: "bold",
    color: theme.palette.primary.text,
    paddingLeft: "10px",
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
  gridContainer: {
    background: theme.palette.type === "dark" ? "#151828" : "white",
    paddingTop: "3px",
  },
  subContainer: {
    marginTop: "15px",
    marginLeft: "20px",
    paddingBottom: "15px",
    marginRight: "15px",
  },
  flexContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between  ",
  },
  ptitle: {
    width: "40%",
    color: "#9fa1a0",
    fontSize: "14px",
    // marginLeft: "35px",
  },
  pvalue: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "#92989B",
    width: "50%",
  },
  copyIcon: {
    fontSize: "20px",

    color: theme.palette.primary.main,
    "&:hover": {
      cursor: "pointer",
    },
  },
}));
